<div class="login-page">

  <div class="row">
    <div class="col-12">
      <div class="header">
        <div class="main_header">
          <img
            class="logo-imgs"
            src="assets/svg/BA Logo with Tagline Standard.svg"
            alt="Blue Pulse"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="row login-bg">

    <div class="col-lg-6 col-md-12 login-left-content">
      <label class="login-title">
        Built for Modern Workforce Management
      </label>
      <p class="login-subtitle">
        Get visibility into working hours, evaluate performance, and gain actionable insights to improve productivity.
      </p>
    </div>

    <div class="col-lg-6 col-md-12 d-flex justify-content-center">
      <mat-card class="forgot_password_matcard">

        <label class="title">
          Reset link sent!
        </label>

        <p class="subtitle">
          We’ve sent the password reset link to registered email address.<br>
          Please check your inbox.
        </p>

        <div class="icon-container">
          <img
            src="assets/svg/email_icon_svg.svg"
            height="50"
            alt="Email sent"
          />
        </div>

        <div class="login-btn-wrapper">
          <button
            mat-raised-button
            class="secondary-login-in-button"
            (click)="goToLogin()">
            Back to Login
          </button>
        </div>

      </mat-card>
    </div>

  </div>
</div>

<app-spinner></app-spinner>
